import { tCaseComponentsLib } from '@/Interfaces/caseComponentsLib';

export const shelves: tCaseComponentsLib = [
    {
        id: 'tcsh_43x47',
        xmlId: 'a5dcdb27-a42b-8244-8ff5-ce1822866039',
        name: 'TC полка малая TCSh 43х47',
        type: 'shelf',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2', 'TC-1947' ],
        blenderName: 'shelfS_tcsh_43x47',
        image: 'dist/src/img/tcsh_43x47.png',
    },
    {
        id: 'tcsh_95x47',
        xmlId: 'a02dae75-68d4-5c2e-5f00-04e86db10916',
        name: 'TC полка большая TCSh 95х47',
        type: 'shelf',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'shelfL_tcsh_95x47',
        image: 'dist/src/img/tcsh_95x47.png',
    },
    {
        id: 'sk_40',
        xmlId: '58b7d1c5-4780-4f7a-d36f-7fbb06d95149',
        name: 'TC полка для ЧПУ SK-40',
        type: 'shelfCNC',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'tc_shelf_chpu_sk_40',
        image: 'dist/src/img/sk_40.png',
    },
    {
        id: 'sk_50',
        xmlId: 'cfa0e27e-8dcd-ff6c-7eb5-be43dd8072f6',
        name: 'TC полка для ЧПУ SK-50',
        type: 'shelfCNC',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'tc_shelf_chpu_sk_50',
        image: 'dist/src/img/sk_50.png',
    },
    {
        id: 'sk_63',
        xmlId: 'e4dc871d-4cb4-2ec8-54e7-7f4e8970c2c4',
        name: 'TC полка для ЧПУ HSK-63',
        type: 'shelfCNC',
        caseModels: [ 'TC-1995', 'TC-1095', 'TC-1995-2' ],
        blenderName: 'tc_shelf_chpu_hsk_63',
        image: 'dist/src/img/sk_63.png',
    },
    {
        id: 'kit_tcsh',
        xmlId: '2f5bb34a-2150-c966-7f0c-65d517c6d4b7',
        name: 'TC гардеробный комплект TCSh',
        type: 'shelf',
        caseModels: [ 'TC-1995', 'TC-1947' ],
        blenderName: 'wardrobe_kit_tcsh',
        image: 'dist/src/img/kit_tcsh.png',
    },
    {
        id: 'sh_amh_tc',
        xmlId: '8dd26325-6804-a225-7875-f8c4a039feb4',
        name: 'Полка AMH TC',
        type: 'shelf',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL' ],
        blenderName: 'shelf_amh_tc',
        image: 'dist/src/img/sh_amh_tc.png',
    },
    {
        id: 'tc_40',
        xmlId: '6ffc30e0-d39d-6a64-0724-60413d721994',
        name: 'Комплект полок AMH TC SK 40 (2шт)',
        type: 'shelfCNC',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL' ],
        blenderName: 'shelf_chpu_amh_tc_40',
        image: 'dist/src/img/tc_40.png',
    },
    {
        id: 'tc_50',
        xmlId: 'fa525540-1efb-e007-381b-50b90b6a1bbf',
        name: 'Комплект полок AMH TC SK 50 (2шт)',
        type: 'shelfCNC',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL' ],
        blenderName: 'shelf_chpu_amh_tc_50',
        image: 'dist/src/img/tc_50.png',
    },
    {
        id: 'tc_63',
        xmlId: '252c3a5d-c53a-9a48-eec9-f76ec24be8a9',
        name: 'Комплект полок AMH TC HSK 63 (2шт)',
        type: 'shelfCNC',
        caseModels: [ 'AMH-TC', 'AMH-TC-EL' ],
        blenderName: 'shelf_chpu_amh_tc_63',
        image: 'dist/src/img/tc_63.png',
    },
    {
        id: 'sh_hard',
        xmlId: '5f9ea887-6b1b-2be3-db98-4462f1dde451',
        name: 'Полка HARD',
        type: 'shelf',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_hard',
        image: 'dist/src/img/sh_hard.png',
    },
    {
        id: 'sl_sh_hard',
        xmlId: '1bf8cc3a-f33c-2641-953c-45c597baee08',
        name: 'Полка выдвижная HARD',
        type: 'shelf',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'sliding_shelf_hard',
        image: 'dist/src/img/sl_sh_hard.png',
    },
    {
        id: 'chpu_hard_40_s1',
        xmlId: '50974e29-7550-eb21-8c61-32df022f8b79',
        name: 'Полка для шкафа HARD SK 40',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_40_s1',
        image: 'dist/src/img/chpu_hard_40.png',
    },
    {
        id: 'chpu_hard_40_s2',
        xmlId: '50974e29-7550-eb21-8c61-32df022f8b79',
        name: 'Полка для шкафа HARD SK 40',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_40_s2',
        image: 'dist/src/img/chpu_hard_40.png',
        noVisible: true,
    },
    {
        id: 'chpu_hard_40_s3',
        xmlId: '50974e29-7550-eb21-8c61-32df022f8b79',
        name: 'Полка для шкафа HARD SK 40',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_40_s3',
        image: 'dist/src/img/chpu_hard_40.png',
        noVisible: true,
    },
    {
        id: 'chpu_hard_50_s1',
        xmlId: '911ba48d-5ba9-748d-b43f-543b6d3adfdb',
        name: 'Полка для шкафа HARD SK 50',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_50_s1',
        image: 'dist/src/img/chpu_hard_50.png',
    },
    {
        id: 'chpu_hard_50_s2',
        xmlId: '911ba48d-5ba9-748d-b43f-543b6d3adfdb',
        name: 'Полка для шкафа HARD SK 50',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_50_s2',
        image: 'dist/src/img/chpu_hard_50.png',
        noVisible: true,
    },
    {
        id: 'chpu_hard_50_s3',
        xmlId: '911ba48d-5ba9-748d-b43f-543b6d3adfdb',
        name: 'Полка для шкафа HARD SK 50',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_50_s3',
        image: 'dist/src/img/chpu_hard_50.png',
        noVisible: true,
    },
    {
        id: 'chpu_hard_63_s1',
        xmlId: 'c00126c4-0b1b-f243-b942-d03e1351ae65',
        name: 'Полка для шкафа HARD HSK 63',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_63_s1',
        image: 'dist/src/img/chpu_hard_63.png',
    },
    {
        id: 'chpu_hard_63_s2',
        xmlId: 'c00126c4-0b1b-f243-b942-d03e1351ae65',
        name: 'Полка для шкафа HARD HSK 63',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_63_s2',
        image: 'dist/src/img/chpu_hard_63.png',
        noVisible: true,
    },
    {
        id: 'chpu_hard_63_s3',
        xmlId: 'c00126c4-0b1b-f243-b942-d03e1351ae65',
        name: 'Полка для шкафа HARD HSK 63',
        type: 'shelfCNCHard',
        caseModels: [ 'HARD-1000', 'HARD-2000' ],
        blenderName: 'shelf_chpu_hard_63_s3',
        image: 'dist/src/img/chpu_hard_63.png',
        noVisible: true,
    },
    {
        id: 'hard_1000',
        xmlId: '810b739a-657d-aa9b-60c5-11c9211df60c',
        name: 'Столешница HARD 1000',
        type: 'shelf',
        caseModels: [ 'HARD-1000' ],
        blenderName: 'table_hard_1000',
        image: 'dist/src/img/hard_1000.png',
    },
];
